import type { ProductKind } from '@iheartjane/taxonomy';

export type { ProductKind } from '@iheartjane/taxonomy';

export const ProductCategoryEnum = [
  'cbd',
  'hybrid',
  'indica',
  'sativa',
] as const;
export type ProductCategory = (typeof ProductCategoryEnum)[number];

export const ProductKindEnum = [
  'edible',
  'extract',
  'flower',
  'gear',
  'grow',
  'merch',
  'pre-roll',
  'tincture',
  'topical',
  'vape',
] as const satisfies readonly ProductKind[];

export const ProductTypesEnum = [
  ...ProductCategoryEnum,
  ...ProductKindEnum,
] as const;
export type ProductType = (typeof ProductTypesEnum)[number];

export const ProductWeightsEnum = [
  'eighth_ounce',
  'gram',
  'half_gram',
  'half_ounce',
  'ounce',
  'quarter_ounce',
  'two_gram',
] as const;

export type ProductWeight = (typeof ProductWeightsEnum)[number];

export const PriceIdEnum = [...ProductWeightsEnum, 'each'] as const;
export type PriceId = (typeof PriceIdEnum)[number];

/** Taken from `api/app/models/cart_limit_rule.rb` */
export const ProductUnitsEnum = ['fl_oz', 'g', 'mg', 'ml', 'oz'] as const;
export type ProductUnits = (typeof ProductUnitsEnum)[number];

export type MaxCartLimitable = { max_cart_quantity: number } & {
  [Key in `max_cart_quantity_${PriceId}`]: number;
};
